module.exports = __webpack_public_path__ + "img/CM-EC-26-Mitsubishi-Established.28a63bfc.jpg";